export default __webpack_public_path__ + "static/media/meBooksLogo.ea41319d.png";